import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-card">
          <h3>Locations</h3>
          <p>1825 Irving street. San Francisco, CA 94122</p>
          <p>1725 Spruce St Suite #101, Riverside, CA 92507</p>
        </div>
        <div className="footer-card">
          <h3>Contact</h3>
          <p>San Francisco: (415) 564-3900</p>
          <p>Riverside: (951) 215-4444</p>
        </div>
        <div className="footer-card">
          <h3>Links</h3>
          <a href="/menu">Menu</a>
          <a href="/catering">Catering</a>
        </div>
      </div>
      <div className="footer-bottom">
        <p>Urban Bites © Copyright 2024 | All Rights Reserved</p>
      </div>
    </footer>
  );
};

export default Footer;
